<!-- ModalEditarItems.vue — Edición de ítems + guías + prioridad + proyectos -->
<template>
  <div class="modal fade" id="modalEditarItems" tabindex="-1" ref="el">
    <div class="modal-dialog modal-xl modal-dialog-scrollable divisan-modal-dialog">
      <div class="modal-content divisan-modal border-0">
        <!-- Header -->
        <div class="modal-header border-0 pb-0">
          <div>
            <div class="numero-pedido-row">
              <template v-if="puedeEditarNumero">
                <span class="fw-bold text-cafe">Editar — Pedido #</span>
                <input
                  v-model="numeroPedidoEdit"
                  type="text"
                  inputmode="numeric"
                  class="numero-pedido-input"
                  :disabled="guardandoNumero"
                  @keyup.enter="confirmarNumeroPedido"
                />
                <button
                  type="button"
                  class="btn-confirmar-numero"
                  :disabled="guardandoNumero || !puedeConfirmarNumero"
                  title="Confirmar número de pedido"
                  @click="confirmarNumeroPedido"
                >
                  <span
                    v-if="guardandoNumero"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  <i v-else class="bi bi-check-lg"></i>
                </button>
              </template>
              <span v-else class="fw-bold text-cafe numero-pedido-texto">
                Editar — Pedido Número {{ numeroPedidoEdit }}
              </span>
            </div>
            <small class="text-verde fw-bold cliente-nombre">
              <span class="badge-cliente-num me-1">{{
                pedidoActual?.cliente_numero
              }}</span>
              {{ pedidoActual?.cliente }}
            </small>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body pt-2">
          <!-- Spinner carga inicial -->
          <div v-if="cargando" class="text-center py-5">
            <div
              class="spinner-border text-verde mb-3"
              style="width: 2.5rem; height: 2.5rem"
            ></div>
            <p class="fw-bold text-cafe">Cargando pedido...</p>
          </div>

          <template v-else>
            <!-- Sin pestañas disponibles (Cancelado) -->
            <div
              v-if="pestanas.length === 0"
              class="estatus-aviso estatus-cancelado mt-2"
            >
              <i class="bi bi-x-circle-fill me-2"></i>
              Este pedido está <strong>cancelado</strong> — no se puede modificar.
            </div>

            <template v-else>
              <!-- Pestañas -->
              <ul class="nav-tabs-custom mt-1 mb-3">
                <li v-for="tab in pestanas" :key="tab.key">
                  <button
                    class="tab-btn"
                    :class="{ active: pestanaActiva === tab.key }"
                    @click="pestanaActiva = tab.key"
                  >
                    <i :class="tab.icon + ' me-1'"></i>{{ tab.label }}
                  </button>
                </li>
              </ul>

              <!-- ── Pestaña: Artículos ───────────────────────────── -->
              <div v-show="pestanaActiva === 'articulos'">
                <PedidoPaso2
                  :items="items"
                  :itemNuevo="itemNuevo"
                  :catArticulos="catArticulos"
                  :analizando="false"
                  :itemsDesdeIa="false"
                  :itemsConMatch="itemsConMatch"
                  :itemsSinMatch="itemsSinMatch"
                  :totalPiezas="totalPiezas"
                  :codigoArticulo="codigoArticulo"
                  :descripcionArticulo="descripcionArticulo"
                  :filtrarArticulos="filtrarArticulos"
                  :asignarArticuloItem="asignarArticuloItem"
                  :agregarItem="agregarItem"
                  :quitarItem="quitarItem"
                />
              </div>

              <!-- ── Pestaña: Prioridad ──────────────────────────── -->
              <div v-show="pestanaActiva === 'prioridad'">
                <p class="prioridad-hint">
                  <i class="bi bi-info-circle me-1"></i>
                  La prioridad afecta el orden de atención del pedido en almacén.
                </p>
                <div class="prioridad-opciones">
                  <button
                    v-for="op in opcionesPrioridad"
                    :key="op.value"
                    class="prioridad-btn"
                    :class="[
                      `prioridad-${op.value.toLowerCase()}`,
                      { active: prioridad === op.value },
                    ]"
                    @click="prioridad = op.value"
                  >
                    <i :class="op.icon + ' me-2'"></i>{{ op.label }}
                  </button>
                </div>
              </div>

              <!-- ── Pestaña: Comentarios ───────────────────────── -->
              <div v-show="pestanaActiva === 'comentarios'">
                <p class="prioridad-hint">
                  <i class="bi bi-info-circle me-1"></i>
                  Las notas son visibles internamente para el equipo.
                </p>
                <div class="comentarios-wrap">
                  <label class="guia-label mb-1">
                    <i class="bi bi-chat-left-text me-1"></i>Notas del pedido
                  </label>
                  <textarea
                    v-model="notas"
                    class="notas-textarea"
                    rows="5"
                    placeholder="Agrega comentarios, observaciones o notas internas sobre este pedido..."
                  ></textarea>
                  <small class="tel-hint">
                    <i class="bi bi-info-circle me-1"></i>
                    Las notas se guardan junto con los demás cambios al presionar "Guardar
                    cambios".
                  </small>
                </div>
              </div>

              <!-- ── Pestaña: Proyectos ──────────────────────────── -->
              <div v-show="pestanaActiva === 'proyectos'">
                <!-- Zona de carga nuevos -->
                <div
                  class="upload-zone mb-4"
                  :class="{ dragging: arrastrando }"
                  @click="$refs.inputProyectos.click()"
                  @dragover.prevent="arrastrando = true"
                  @dragleave.prevent="arrastrando = false"
                  @drop.prevent="handleDropProyectos"
                >
                  <input
                    ref="inputProyectos"
                    type="file"
                    accept="application/pdf"
                    multiple
                    class="d-none"
                    @change="handleChangeProyectos"
                  />
                  <div class="upload-inner">
                    <i class="bi bi-file-earmark-plus upload-icon"></i>
                    <div>
                      <p class="fw-bold text-cafe mb-0">Arrastra PDFs de proyecto aquí</p>
                      <small class="text-muted"
                        >o haz clic para seleccionar · puedes subir varios a la vez</small
                      >
                    </div>
                  </div>
                </div>

                <!-- Estado vacío total -->
                <div
                  v-if="proyectosGuardados.length === 0 && proyectosNuevos.length === 0"
                  class="vacio-container"
                >
                  <i class="bi bi-file-earmark-pdf"></i>
                  <p class="mt-2 mb-0">Sin proyectos adjuntos</p>
                  <small>Sube los PDFs de diseño para que Tere pueda revisarlos</small>
                </div>

                <div v-else class="proyectos-lista">
                  <!-- ── Proyectos ya guardados en BD ─────────────── -->
                  <template v-if="proyectosGuardados.length > 0">
                    <small class="text-cafe fw-bold d-block mb-2">
                      <i class="bi bi-cloud-check me-1 text-verde"></i>
                      {{ proyectosGuardados.length }} proyecto(s) guardado(s)
                    </small>

                    <div
                      v-for="p in proyectosGuardados"
                      :key="'g-' + p.id"
                      class="proyecto-card"
                    >
                      <div class="proyecto-header">
                        <div class="proyecto-meta">
                          <i class="bi bi-file-earmark-pdf-fill me-2 text-danger"></i>
                          <span class="proyecto-nombre">{{
                            p.archivo.split("/").pop()
                          }}</span>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <button
                            class="btn-toggle-preview"
                            @click="p._preview = !p._preview"
                            :title="p._preview ? 'Ocultar preview' : 'Ver PDF'"
                          >
                            <i
                              class="bi"
                              :class="p._preview ? 'bi-eye-slash' : 'bi-eye'"
                            ></i>
                            {{ p._preview ? "Ocultar" : "Ver" }}
                          </button>
                          <button
                            class="btn-quitar"
                            :disabled="eliminandoProyecto === p.id"
                            @click="handleEliminarProyecto(p.id)"
                            title="Eliminar proyecto"
                          >
                            <span
                              v-if="eliminandoProyecto === p.id"
                              class="spinner-border spinner-border-sm"
                            ></span>
                            <i v-else class="bi bi-trash3"></i>
                          </button>
                        </div>
                      </div>

                      <!-- Preview del PDF guardado (URL de S3) -->
                      <div v-if="p._preview" class="preview-container">
                        <embed
                          :src="p.archivo"
                          type="application/pdf"
                          class="pdf-embed"
                        />
                      </div>
                    </div>
                  </template>

                  <!-- ── Proyectos nuevos pendientes de subir ──────── -->
                  <template v-if="proyectosNuevos.length > 0">
                    <small class="text-cafe fw-bold d-block mb-2 mt-3">
                      <i class="bi bi-clock-history me-1 text-warning-custom"></i>
                      {{ proyectosNuevos.length }} pendiente(s) de guardar
                    </small>

                    <div
                      v-for="(p, idx) in proyectosNuevos"
                      :key="'n-' + idx"
                      class="proyecto-card proyecto-card-nuevo"
                    >
                      <div class="proyecto-header">
                        <div class="proyecto-meta">
                          <i class="bi bi-file-earmark-pdf-fill me-2 text-danger"></i>
                          <span class="proyecto-nombre">{{ p.archivo.name }}</span>
                          <span class="proyecto-size text-muted ms-2"
                            >({{ formatSize(p.archivo.size) }})</span
                          >
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <button
                            class="btn-toggle-preview"
                            @click="p._preview = !p._preview"
                          >
                            <i
                              class="bi"
                              :class="p._preview ? 'bi-eye-slash' : 'bi-eye'"
                            ></i>
                            {{ p._preview ? "Ocultar" : "Ver" }}
                          </button>
                          <button
                            class="btn-quitar"
                            @click="quitarProyectoNuevo(idx)"
                            title="Quitar"
                          >
                            <i class="bi bi-x-lg"></i>
                          </button>
                        </div>
                      </div>

                      <!-- Preview del PDF nuevo (objectURL) -->
                      <div v-if="p._preview && p._objectUrl" class="preview-container">
                        <embed
                          :src="p._objectUrl"
                          type="application/pdf"
                          class="pdf-embed"
                        />
                      </div>
                    </div>

                    <!-- Botón subir nuevos -->
                    <button
                      class="btn-subir-proyectos mt-2"
                      :disabled="subiendoProyectos"
                      @click="handleSubirProyectos"
                    >
                      <span
                        v-if="subiendoProyectos"
                        class="spinner-border spinner-border-sm me-2"
                      ></span>
                      <i v-else class="bi bi-cloud-upload me-2"></i>
                      {{
                        subiendoProyectos
                          ? "Subiendo..."
                          : `Guardar ${proyectosNuevos.length} proyecto(s)`
                      }}
                    </button>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </div>

        <!-- Footer -->
        <div class="modal-footer border-0 pt-0">
          <button
            class="btn btn-cancelar me-auto"
            data-bs-dismiss="modal"
            :disabled="guardando"
          >
            Cancelar
          </button>
          <!-- Ocultar "Guardar cambios" en pedidos entregados y en pestaña proyectos -->
          <button
            v-if="pestanas.length > 0 && pestanaActiva !== 'proyectos'"
            class="btn btn-nuevo"
            @click="handleGuardar"
            :disabled="guardando || cargando || botonDeshabilitado"
          >
            <span v-if="guardando" class="spinner-border spinner-border-sm me-2"></span>
            {{ guardando ? "Guardando..." : "Guardar cambios" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { Modal } from "bootstrap";
import PedidoPaso2 from "./PedidoPaso2.vue";
import { usePedidoItemsEdit } from "./composables/usePedidoItemsEdit.js";
import {
  agregarProyectoPedido,
  eliminarProyectoPedido,
  actualizarPedido,
} from "@/utils/api_backend.js";
import Swal from "sweetalert2";

const props = defineProps({
  catArticulos: { type: Array, default: () => [] },
});
const emit = defineEmits(["guardado"]);

const el = ref(null);
const prioridad = ref("");
const notas = ref("");
let modalInstance = null;

// ── Número de pedido editable ──────────────────────────────
const numeroPedidoEdit = ref("");
const guardandoNumero = ref(false);

const puedeEditarNumero = computed(
  () => pedidoActual.value?.estatus_almacen === "En proceso"
);

const puedeConfirmarNumero = computed(() => {
  if (!puedeEditarNumero.value) return false;
  const val = numeroPedidoEdit.value.trim();
  return val !== "" && val !== String(pedidoActual.value?.numero_pedido ?? "");
});

async function confirmarNumeroPedido() {
  if (!puedeConfirmarNumero.value || !pedidoActual.value) return;
  const anterior = pedidoActual.value.numero_pedido;
  const nuevo = numeroPedidoEdit.value.trim();
  guardandoNumero.value = true;
  try {
    await actualizarPedido(anterior, { numero_pedido: nuevo });
    pedidoActual.value = { ...pedidoActual.value, numero_pedido: nuevo };
    Swal.fire({
      icon: "success",
      title: "Número de pedido actualizado",
      timer: 1500,
      showConfirmButton: false,
    });
    emit("guardado");
  } catch (err) {
    console.error("Error actualizando número de pedido:", err.response?.data);
    numeroPedidoEdit.value = String(anterior);
    Swal.fire(
      "Error",
      err.response?.data?.numero_pedido?.[0] ||
        err.response?.data?.detail ||
        "No se pudo actualizar el número de pedido.",
      "error"
    );
  } finally {
    guardandoNumero.value = false;
  }
}

// Factura, guías y envíos por WhatsApp viven ahora en ModalEntregaPedido.vue:
// aplican a pedidos entregados, que este modal ya no recibe.

// ── Proyectos ─────────────────────────────────────────────
const inputProyectos = ref(null);
const arrastrando = ref(false);
// Proyectos ya persistidos en BD (vienen de pedido.proyectos)
const proyectosGuardados = ref([]);
// Proyectos nuevos que el usuario acaba de seleccionar (File objects)
const proyectosNuevos = ref([]);
const subiendoProyectos = ref(false);
const eliminandoProyecto = ref(null);

const catArticulosRef = computed(() => props.catArticulos);

const {
  pedidoActual,
  items,
  itemNuevo,
  guardando,
  cargando,
  totalPiezas,
  itemsConMatch,
  itemsSinMatch,
  codigoArticulo,
  descripcionArticulo,
  filtrarArticulos,
  asignarArticuloItem,
  agregarItem,
  quitarItem,
  cargarItems,
  guardarCambios,
  reset,
} = usePedidoItemsEdit(catArticulosRef);

// ── Computed ──────────────────────────────────────────────
const opcionesPrioridad = [
  { value: "Alta", label: "Alta", icon: "bi bi-arrow-up-circle-fill" },
  { value: "Media", label: "Media", icon: "bi bi-dash-circle-fill" },
  { value: "Baja", label: "Baja", icon: "bi bi-arrow-down-circle-fill" },
];

const esCancelado = computed(() => pedidoActual.value?.estatus_almacen === "Cancelado");

const pestanas = computed(() => {
  if (esCancelado.value) return [];
  return [
    { key: "articulos", label: "Artículos", icon: "bi bi-box-seam" },
    { key: "prioridad", label: "Prioridad", icon: "bi bi-arrow-up-circle" },
    { key: "comentarios", label: "Comentarios", icon: "bi bi-chat-left-text" },
    { key: "proyectos", label: "Proyectos", icon: "bi bi-file-earmark-pdf" },
  ];
});

const pestanaActiva = ref("articulos");

const botonDeshabilitado = computed(() => {
  if (pestanaActiva.value === "articulos")
    return items.value.filter((i) => i.articulo_id).length === 0;
  return false;
});

// ── Ciclo de vida ─────────────────────────────────────────
onMounted(() => {
  modalInstance = new Modal(el.value);
});

// ── Abrir modal ───────────────────────────────────────────
async function abrir(pedido) {
  reset();
  prioridad.value = pedido.prioridad || "Media";
  notas.value = pedido.notas || "";
  numeroPedidoEdit.value = String(pedido.numero_pedido);
  guardandoNumero.value = false;

  // Cargar proyectos guardados — agregar _preview: false a cada uno
  proyectosGuardados.value = (pedido.proyectos || []).map((p) => ({
    ...p,
    _preview: false,
  }));
  proyectosNuevos.value = [];

  pestanaActiva.value = "articulos";

  modalInstance.show();
  await cargarItems(pedido);
}
defineExpose({ abrir });

// ── Proyectos: seleccionar / drop ─────────────────────────
function handleChangeProyectos(e) {
  agregarArchivosProyecto([...e.target.files]);
  e.target.value = "";
}
function handleDropProyectos(e) {
  arrastrando.value = false;
  const archivos = [...e.dataTransfer.files].filter((f) => f.type === "application/pdf");
  agregarArchivosProyecto(archivos);
}
function agregarArchivosProyecto(archivos) {
  // Evitar duplicados contra los pendientes por nombre de archivo
  const nombresPendientes = proyectosNuevos.value.map((p) => p.archivo.name);
  const sinDup = archivos.filter((f) => !nombresPendientes.includes(f.name));
  proyectosNuevos.value.push(
    ...sinDup.map((archivo) => ({
      archivo,
      _preview: false,
      _objectUrl: URL.createObjectURL(archivo),
    }))
  );
}
function quitarProyectoNuevo(idx) {
  const lista = proyectosNuevos.value;
  if (lista[idx]._objectUrl) URL.revokeObjectURL(lista[idx]._objectUrl);
  lista.splice(idx, 1);
}

// ── Proyectos: subir nuevos ───────────────────────────────
async function handleSubirProyectos() {
  subiendoProyectos.value = true;
  try {
    const resultados = await Promise.allSettled(
      proyectosNuevos.value.map((p) => {
        const fd = new FormData();
        fd.append("archivo", p.archivo);
        return agregarProyectoPedido(pedidoActual.value.numero_pedido, fd);
      })
    );

    const exitosos = [];
    const fallidos = [];
    resultados.forEach((r, idx) => {
      if (r.status === "fulfilled") {
        exitosos.push({ ...r.value.data, _preview: false });
      } else {
        fallidos.push(proyectosNuevos.value[idx].archivo.name);
      }
    });

    // Mover los exitosos a guardados y limpiar sus objectURLs
    proyectosNuevos.value
      .filter((_, i) => resultados[i].status === "fulfilled")
      .forEach((p) => URL.revokeObjectURL(p._objectUrl));

    proyectosGuardados.value.push(...exitosos);
    proyectosNuevos.value = proyectosNuevos.value.filter(
      (_, i) => resultados[i].status === "rejected"
    );

    if (fallidos.length > 0) {
      alert(`No se pudieron subir: ${fallidos.join(", ")}`);
    }

    emit("guardado"); // refrescar lista de pedidos para que sincronice proyectos
  } catch (err) {
    console.error("Error subiendo proyectos:", err);
  } finally {
    subiendoProyectos.value = false;
  }
}

// ── Proyectos: eliminar guardado ──────────────────────────
async function handleEliminarProyecto(proyectoId) {
  eliminandoProyecto.value = proyectoId;
  try {
    await eliminarProyectoPedido(pedidoActual.value.numero_pedido, proyectoId);
    proyectosGuardados.value = proyectosGuardados.value.filter(
      (p) => p.id !== proyectoId
    );
    emit("guardado");
  } catch (err) {
    console.error("Error eliminando proyecto:", err.response?.data);
    alert(err.response?.data?.detail || "No se pudo eliminar el proyecto.");
  } finally {
    eliminandoProyecto.value = null;
  }
}

// ── Guardar cambios ───────────────────────────────────────
async function handleGuardar() {
  await guardarCambios(
    prioridad.value,
    () => {
      modalInstance.hide();
      emit("guardado");
    },
    notas.value
  );
}

// ── Helpers proyectos ─────────────────────────────────────
function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

</script>

<style scoped>
/* ── Posicionamiento del modal ──────────────────────────── */
.divisan-modal-dialog {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
  margin: 0.5rem auto;
}
@media (max-width: 991.98px) {
  .divisan-modal-dialog {
    align-items: flex-start;
    margin-top: 73px;
    margin-bottom: 8px;
    min-height: unset;
    width: calc(100% - 16px);
    max-width: 100%;
  }
}

.text-cafe {
  color: var(--d-brown);
}
.text-verde {
  color: var(--d-green);
}
.text-wa {
  color: #25d366;
}
.text-success {
  color: #2e7d32 !important;
}
.text-warning-custom {
  color: #b45309;
}

.divisan-modal {
  background-color: var(--d-cream);
  border: 2px solid var(--d-brown);
  border-radius: 20px;
}
.badge-cliente-num {
  background: var(--d-green-dark);
  color: var(--d-cream);
  font-family: var(--d-font-mono);
  font-size: 0.78rem;
  font-weight: 700;
  border-radius: 5px;
  padding: 1px 7px;
}

/* ── Número de pedido editable ─────────────────────────────── */
.numero-pedido-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.numero-pedido-input {
  width: 140px;
  border: 1.5px solid var(--d-border);
  border-radius: var(--d-radius-sm);
  padding: 3px 8px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--d-brown);
  font-family: var(--d-font-mono);
  background: #fff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.numero-pedido-input:focus {
  border-color: var(--d-green);
  box-shadow: 0 0 0 3px rgba(96, 108, 56, 0.12);
}
.numero-pedido-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn-confirmar-numero {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background: #2e7d32;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}
.btn-confirmar-numero:hover:not(:disabled) {
  background: #1b5e20;
}
.btn-confirmar-numero:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.numero-pedido-lock {
  color: rgba(64, 34, 8, 0.35);
  font-size: 0.85rem;
  flex-shrink: 0;
}
.numero-pedido-texto {
  display: block;
}
.cliente-nombre {
  display: block;
  font-size: 0.76rem;
  line-height: 1.35;
  word-break: break-word;
}
@media (max-width: 480px) {
  .cliente-nombre {
    font-size: 0.7rem;
  }
}

/* ── Pestañas ───────────────────────────────────────────── */
.nav-tabs-custom {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 6px;
  border-bottom: 2px solid rgba(64, 34, 8, 0.15);
  flex-wrap: wrap;
}
.tab-btn {
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  padding: 7px 16px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #888;
  cursor: pointer;
  border-radius: 6px 6px 0 0;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
}
.tab-btn:hover {
  color: var(--d-brown);
  background: rgba(64, 34, 8, 0.05);
}
.tab-btn.active {
  color: var(--d-brown);
  border-bottom-color: var(--d-brown);
  background: rgba(64, 34, 8, 0.06);
}

/* ── Avisos de estatus ──────────────────────────────────── */
.estatus-aviso {
  border-radius: 8px;
  padding: 0.6rem 1rem;
  font-size: 0.88rem;
  font-weight: 700;
}
.estatus-cancelado {
  background: #fdecea;
  color: #c62828;
  border: 1px solid rgba(198, 40, 40, 0.3);
}

/* ── Upload zona proyectos ──────────────────────────────── */
.upload-zone {
  border: 2px dashed var(--d-green);
  border-radius: 12px;
  background: rgba(96, 108, 56, 0.05);
  padding: 0.85rem 1.25rem;
  cursor: pointer;
  transition: 0.2s;
}
.upload-zone:hover,
.upload-zone.dragging {
  border-color: var(--d-green-dark);
  background: rgba(40, 54, 24, 0.08);
}
.upload-inner {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}
.upload-icon {
  font-size: 1.7rem;
  color: var(--d-green);
  flex-shrink: 0;
}

/* ── Vacío ──────────────────────────────────────────────── */
.vacio-container {
  text-align: center;
  padding: 1.75rem;
  color: var(--d-brown);
  opacity: 0.4;
  font-weight: 700;
}
.vacio-container i {
  font-size: 2.4rem;
  display: block;
}
.vacio-container small {
  font-weight: 400;
  font-size: 0.8rem;
}

/* ── Cards proyectos ────────────────────────────────────── */
.proyectos-lista {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.proyecto-card {
  border: 1px solid rgba(96, 108, 56, 0.3);
  border-radius: 10px;
  background: white;
  overflow: hidden;
}
.proyecto-card-nuevo {
  border-color: rgba(180, 83, 9, 0.35);
  background: #fffbf5;
}

.proyecto-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0.75rem 0.5rem;
  background: rgba(96, 108, 56, 0.06);
  border-bottom: 1px solid rgba(96, 108, 56, 0.12);
}
.proyecto-card-nuevo .proyecto-header {
  background: rgba(180, 83, 9, 0.05);
  border-bottom-color: rgba(180, 83, 9, 0.12);
}

.proyecto-meta {
  display: flex;
  align-items: center;
  min-width: 0;
}
.proyecto-nombre {
  font-weight: 700;
  font-size: 0.85rem;
  color: var(--d-green-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 340px;
}
.proyecto-size {
  font-size: 0.75rem;
  flex-shrink: 0;
}

.btn-toggle-preview {
  background: none;
  border: 1px solid var(--d-green);
  color: var(--d-green);
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 6px;
  padding: 2px 9px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: 0.15s;
  white-space: nowrap;
}
.btn-toggle-preview:hover {
  background: var(--d-green);
  color: var(--d-cream);
}

.btn-quitar {
  background: none;
  border: none;
  color: #c0392b;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;
  transition: background 0.15s;
  line-height: 1;
  flex-shrink: 0;
}
.btn-quitar:hover:not(:disabled) {
  background: rgba(192, 57, 43, 0.1);
}
.btn-quitar:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.proyecto-input {
  border: 1px solid var(--d-green);
  border-radius: 8px;
  color: var(--d-brown);
  background: white;
}
.proyecto-input:focus {
  border-color: var(--d-green-dark);
  box-shadow: 0 0 0 0.2rem rgba(40, 54, 24, 0.15);
  outline: none;
}

/* ── Preview PDF ────────────────────────────────────────── */
.preview-container {
  border-top: 1px solid rgba(96, 108, 56, 0.15);
  background: #f5f5f5;
}
.pdf-embed {
  width: 100%;
  height: 480px;
  display: block;
  border: none;
}

/* ── Botón subir proyectos ──────────────────────────────── */
.btn-subir-proyectos {
  width: 100%;
  background: var(--d-brown);
  color: var(--d-cream);
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background 0.15s;
}
.btn-subir-proyectos:hover:not(:disabled) {
  background: var(--d-green-dark);
}
.btn-subir-proyectos:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Todo lo demás (sin cambios) ───────────────────────── */
.guia-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
  margin: 0;
}
.guia-input {
  flex: 1;
  border: 1px solid rgba(96, 108, 56, 0.45);
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 0.88rem;
  color: var(--d-brown);
  background: white;
  outline: none;
  transition: border-color 0.15s;
}
.guia-input:focus {
  border-color: var(--d-green-dark);
  box-shadow: 0 0 0 3px rgba(40, 54, 24, 0.1);
}
.guias-guardadas {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.guia-guardada-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(96, 108, 56, 0.07);
  border: 1px solid rgba(96, 108, 56, 0.2);
  border-radius: 8px;
  padding: 6px 10px;
}
.guia-badge-paq {
  background: var(--d-green-dark);
  color: var(--d-cream);
  font-size: 0.72rem;
  font-weight: 700;
  border-radius: 4px;
  padding: 2px 8px;
  white-space: nowrap;
  flex-shrink: 0;
}
.guia-num-texto {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--d-brown);
  font-family: var(--d-font-mono);
  flex: 1;
}
.btn-quitar-guia {
  background: none;
  border: 1px solid rgba(198, 40, 40, 0.4);
  color: #c62828;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.8rem;
  flex-shrink: 0;
  transition: all 0.15s;
}
.btn-quitar-guia:hover:not(:disabled) {
  background: #c62828;
  color: white;
}
.btn-quitar-guia:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.sin-guias-hint {
  font-size: 0.82rem;
  color: rgba(64, 34, 8, 0.45);
  margin: 0 0 6px;
  font-style: italic;
}
.nueva-guia-wrap {
  display: flex;
  gap: 6px;
  align-items: stretch;
  flex-wrap: wrap;
}
.guia-input-nueva {
  min-width: 160px;
}
.custom-select-wrapper {
  position: relative;
  flex-shrink: 0;
}
.paq-select-display {
  border: 1px solid rgba(96, 108, 56, 0.45);
  border-radius: 8px;
  padding: 7px 28px 7px 12px;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--d-brown);
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  min-width: 150px;
  white-space: nowrap;
  user-select: none;
  transition: border-color 0.15s;
}
.paq-select-display.placeholder {
  color: rgba(64, 34, 8);
  font-weight: 400;
}
.paq-select-display:hover {
  border-color: var(--d-green-dark);
}
.paq-dropdown {
  position: absolute;
  top: calc(100% + 3px);
  left: 0;
  min-width: 100%;
  z-index: 1090;
  background: white;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(40, 54, 24, 0.15);
  max-height: 200px;
  overflow-y: auto;
}
.paq-dropdown-item {
  padding: 8px 12px;
  font-size: 0.88rem;
  color: var(--d-brown);
  cursor: pointer;
  transition: background 0.12s;
  border-bottom: 1px solid rgba(96, 108, 56, 0.08);
}
.paq-dropdown-item:last-child {
  border-bottom: none;
}
.paq-dropdown-item:hover,
.paq-dropdown-item.selected {
  background: rgba(96, 108, 56, 0.12);
}
.prioridad-hint {
  font-size: 0.83rem;
  color: #888;
  margin-bottom: 1.2rem;
}
.prioridad-opciones {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.prioridad-btn {
  flex: 1;
  min-width: 110px;
  padding: 14px 10px;
  border-radius: 12px;
  border: 2px solid transparent;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  background: #f5f5f5;
  color: #555;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.prioridad-btn:hover {
  filter: brightness(0.95);
}
.prioridad-alta {
  background: #fff3e0;
  color: #e65100;
}
.prioridad-alta.active {
  background: #e65100;
  color: #fff;
  border-color: #e65100;
}
.prioridad-media {
  background: #fff8e1;
  color: #f9a825;
}
.prioridad-media.active {
  background: #f9a825;
  color: #fff;
  border-color: #f9a825;
}
.prioridad-baja {
  background: #e8f5e9;
  color: #2e7d32;
}
.prioridad-baja.active {
  background: #2e7d32;
  color: #fff;
  border-color: #2e7d32;
}
.entrega-bloque {
  background: rgba(96, 108, 56, 0.04);
  border: 1px solid rgba(96, 108, 56, 0.18);
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.btn-icon-only {
  padding: 7px 12px;
}

/* ── Fila principal: Izq (Factura + Notificación) | Der (Guías 50%) ── */
.entrega-grid-principal {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 10px;
}
.entrega-col-izq,
.entrega-col-der {
  flex: 1 1 50%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.entrega-col-izq > .entrega-bloque,
.entrega-col-der > .entrega-bloque {
  margin-bottom: 0;
}
.entrega-bloque-guias {
  flex: 1;
}
@media (max-width: 767.98px) {
  .entrega-grid-principal {
    flex-direction: column;
    align-items: stretch;
  }
  .entrega-col-izq,
  .entrega-col-der {
    flex: 1 1 auto;
    width: 100%;
  }
}
.entrega-bloque-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--d-green);
}
.entrega-badge-count {
  margin-left: auto;
  background: var(--d-green);
  color: var(--d-cream);
  font-size: 0.72rem;
  font-weight: 700;
  border-radius: 10px;
  padding: 1px 8px;
}
.notif-accion-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.notif-checks {
  display: flex;
  gap: 8px;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
}
.notif-check-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 6px;
}
.notif-check-item.ok {
  color: #2e7d32;
  background: rgba(46, 125, 50, 0.08);
}
.notif-check-item.falta {
  color: #9e9e9e;
  background: rgba(0, 0, 0, 0.04);
}
.notif-check-item .bi {
  font-size: 0.78rem;
}
.notif-estado-badge {
  margin-left: auto;
  font-size: 0.72rem;
  font-weight: 700;
  border-radius: 8px;
  padding: 2px 9px;
  display: inline-flex;
  align-items: center;
}
.notif-estado-badge.polling {
  background: rgba(249, 168, 37, 0.12);
  color: #92400e;
  border: 1px solid rgba(249, 168, 37, 0.35);
}
.notif-estado-badge.success {
  background: rgba(46, 125, 50, 0.1);
  color: #1b5e20;
  border: 1px solid rgba(46, 125, 50, 0.3);
}
.notif-estado-badge.failure {
  background: rgba(198, 40, 40, 0.08);
  color: #b71c1c;
  border: 1px solid rgba(198, 40, 40, 0.25);
}
.notif-resultado {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 0.83rem;
  font-weight: 600;
}
.notif-resultado.success {
  background: rgba(46, 125, 50, 0.08);
  color: #1b5e20;
  border: 1px solid rgba(46, 125, 50, 0.25);
}
.notif-resultado.failure {
  background: rgba(198, 40, 40, 0.07);
  color: #b71c1c;
  border: 1px solid rgba(198, 40, 40, 0.2);
}
.factura-zona-wrap {
  flex: 1;
  min-width: 0;
}
.comentarios-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.notas-textarea {
  width: 100%;
  border: 1px solid rgba(96, 108, 56, 0.4);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.88rem;
  color: var(--d-brown);
  background: #fff;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
  transition: border-color 0.15s;
}
.notas-textarea:focus {
  outline: none;
  border-color: var(--d-green);
  box-shadow: 0 0 0 3px rgba(96, 108, 56, 0.12);
}
.notas-fila {
  display: flex;
  align-items: stretch;
  gap: 10px;
}
.notas-textarea-compacta {
  flex: 1 1 75%;
  min-width: 0;
  min-height: unset;
  height: 40px;
  resize: none;
}
.btn-guardar-notas {
  background: var(--d-green);
  color: var(--d-cream);
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  align-self: flex-start;
}
.notas-fila .btn-guardar-notas {
  flex: 0 0 25%;
  align-self: stretch;
}
.btn-guardar-notas:hover:not(:disabled) {
  background: var(--d-green-dark);
}
.btn-guardar-notas:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn-accion {
  flex-shrink: 0;
  border: none;
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 0.83rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: background 0.15s, opacity 0.15s;
  white-space: nowrap;
}
.btn-accion:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.btn-wa-accion {
  background: #25d366;
  color: white;
}
.btn-wa-accion:hover:not(:disabled) {
  background: #128c4f;
}
.btn-factura-accion {
  background: #1565c0;
  color: white;
}
.btn-factura-accion:hover:not(:disabled) {
  background: #0d47a1;
}
.btn-agregar-guia {
  background: var(--d-green);
  color: var(--d-cream);
}
.btn-agregar-guia:hover:not(:disabled) {
  background: var(--d-green-dark);
}
.factura-zona {
  flex: 1;
  min-width: 0;
  border: 1.5px dashed rgba(96, 108, 56, 0.5);
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 0.84rem;
  color: #555;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 2px;
  transition: border-color 0.15s, background 0.15s;
  min-height: 38px;
}
.factura-zona a,
.factura-zona span {
  max-width: 100%;
  overflow-wrap: break-word;
}
.factura-zona:hover {
  border-color: var(--d-green-dark);
  background: rgba(40, 54, 24, 0.04);
}
.tel-hint {
  font-size: 0.71rem;
  color: rgba(64, 34, 8, 0.5);
  display: block;
}
.btn-nuevo {
  background-color: var(--d-brown);
  color: var(--d-cream);
  border: none;
  font-weight: 600;
  border-radius: 8px;
}
.btn-nuevo:hover:not(:disabled) {
  background-color: var(--d-green-dark);
  color: var(--d-cream);
}
.btn-nuevo:disabled {
  opacity: 0.5;
}
.btn-cancelar {
  background: none;
  border: 1px solid var(--d-green);
  color: var(--d-green);
  font-weight: 600;
  border-radius: 8px;
}
.btn-cancelar:hover {
  background: rgba(96, 108, 56, 0.08);
}

@media (max-width: 640px) {
  .notif-accion-row {
    flex-direction: column;
    align-items: stretch;
  }
  .notif-accion-row .btn-accion {
    width: 100%;
    justify-content: center;
  }
  .nueva-guia-wrap {
    flex-direction: column;
  }
  .custom-select-wrapper {
    width: 100%;
  }
  .paq-select-display {
    min-width: unset;
  }
  .btn-accion {
    width: 100%;
    justify-content: center;
  }
  .notas-fila {
    flex-direction: column;
    align-items: stretch;
  }
  .notas-textarea-compacta {
    width: 100%;
    height: auto;
    min-height: 70px;
    resize: vertical;
  }
  .notas-fila .btn-guardar-notas {
    width: 100%;
    justify-content: center;
  }
}
</style>
